import React from "react";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft, IconHomeHeart } from "@tabler/icons-react";
import { useI18n } from "@/contexts/I18nContext";
import { useChildren, initials } from "@/pages/app/circulo/hooks";

export default function CirculoFamilia() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const { items, loading } = useChildren();

  return (
    <>
      <div className="subbar">
        <button className="btn-ghost btn text-[12px] px-2 py-1" onClick={() => nav("/app")} data-testid="cf-back">
          <IconArrowLeft size={13} /> {t("app.back")}
        </button>
        <span className="t">CÍRCULO · FAMILIA</span>
      </div>
      <div className="wrap-app py-10 max-w-[860px]">
        <p className="eyebrow">{lang === "es" ? "Tu círculo" : "Your circle"}</p>
        <h1 className="font-display font-medium text-[26px] mt-2">
          {lang === "es" ? "Tus hijos en el instituto" : "Your children"}
        </h1>
        <p className="text-muted text-[14px] mt-1">
          {lang === "es"
            ? "Toca a tu hijo para abrir su expediente."
            : "Tap your child to open the case file."}
        </p>

        <div className="mt-8">
          {loading ? (
            <p className="text-tert text-[12px] font-mono uppercase">Cargando…</p>
          ) : items.length === 0 ? (
            <div className="card">
              <div className="w-11 h-11 rounded-full bg-teal-soft text-teal-deep flex items-center justify-center mb-3">
                <IconHomeHeart size={22} />
              </div>
              <p className="text-[14px]">
                {lang === "es"
                  ? "Todavía no hay un expediente abierto para ti. Escríbele a Mariela para que te dé de alta."
                  : "No case is open for you yet. Ask Mariela to add you."}
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              {items.map((c) => (
                <button
                  key={c.id}
                  onClick={() => nav(`/app/circulo/child/${c.id}`)}
                  className="w-full card text-left flex items-center justify-between hover:border-teal transition"
                  data-testid={`child-open-${c.id}`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-full bg-teal-deep text-white flex items-center justify-center font-display text-[15px] font-medium">
                      {initials(c.name)}
                    </div>
                    <div>
                      <p className="font-display text-[17px] font-medium">{c.name}</p>
                      <p className="text-tert text-[12.5px]">{c.age} años · {c.grade || "—"} · {c.condition || "—"}</p>
                    </div>
                  </div>
                  <span className="text-teal text-[12.5px] font-medium">{lang === "es" ? "Abrir" : "Open"} →</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
